export default __webpack_public_path__ + "static/media/VideoFXBanner.470fcbb6.svg";